/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import useStyles from 'isomorphic-style-loader/useStyles';

// constants
import { BREAKPOINTS } from 'constants/index';

// assets
import CssSlider from 'components/slider.scss';
import CssBoxSlider from 'components/Home/box-slider.scss';

const Carousel = React.forwardRef((props, ref) => {
  const { columns, children, className, width } = props;
  useStyles(CssBoxSlider, CssSlider);
  const slidesToShow = amount => Math.min(amount, children.length);
  const isClient = typeof window !== 'undefined';

  // React slick has a nice responsive mode , but it only works on the client.
  // On the server we'll need to disable it and manually calculate how many items to show.
  // This could be better if react-slick allowed us to manually specify the width.
  let columnsToRender = columns;
  if (width < BREAKPOINTS.TABLET_HORIZONTAL) {
    columnsToRender = 3;
  }
  if (width < BREAKPOINTS.TABLET_VERTICAL) {
    columnsToRender = 2;
  }
  if (width < BREAKPOINTS.PHONE_VERTICAL) {
    columnsToRender = 1;
  }

  return (
    <div ref={ref} className={className}>
      <Slider
        className="box-slider box-slider--arrow-stable"
        infinite={false}
        slidesToShow={slidesToShow(columnsToRender)}
        responsive={
          isClient
            ? [
                {
                  breakpoint: BREAKPOINTS.TABLET_HORIZONTAL,
                  settings: {
                    slidesToShow: slidesToShow(3),
                  },
                },
                {
                  breakpoint: BREAKPOINTS.TABLET_VERTICAL,
                  settings: {
                    slidesToShow: slidesToShow(2),
                  },
                },
                {
                  breakpoint: BREAKPOINTS.PHONE_VERTICAL,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ]
            : null
        }
      >
        {children.map((item, i) => <div key={`carousel-item-${item.key}-${i}`}>{item}</div>)}
      </Slider>
    </div>
  );
});

Carousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  columns: PropTypes.number,
  width: PropTypes.number,
};

Carousel.defaultProps = {
  className: null,
  columns: 4,
  width: 800,
};

export default Carousel;
